import { render } from "./SideNav.vue?vue&type=template&id=5b9dec4c"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=5b9dec4c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SideNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b9dec4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b9dec4c', __exports__)) {
    api.reload('5b9dec4c', __exports__)
  }
  
  module.hot.accept("./SideNav.vue?vue&type=template&id=5b9dec4c", () => {
    api.rerender('5b9dec4c', render)
  })

}


export default __exports__